export default __webpack_public_path__ + "static/media/Raider's Belt of the Grasslands.7a0755ab.jpg";